/**
 * Returns the route where the plan of a workspace can be changed, based on its
 * usage data. A workspace on a free trial has no subscription, so it goes to the
 * page where a new subscription can be created.
 */
export const getChangePlanRoute = (workspaceUsage) =>
  workspaceUsage.subscription_id
    ? {
        name: 'subscription',
        params: { subscriptionId: workspaceUsage.subscription_id },
      }
    : { name: 'new-subscription' }
